import React from "react";
import { connect, ConnectedProps } from "react-redux";
import {
	CartesianGrid,
	Line,
	LineChart,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
import { Dispatch } from "redux";
import { IStore } from "redux/store";

interface IChartData {
	date: string;
	value: number;
}

const chartData: IChartData[] = [
	{ date: "12 Jan", value: 23400 },
	{ date: "13", value: 23410 },
	{ date: "14", value: 23420 },
	{ date: "15", value: 23510 },
	{ date: "16", value: 23680 },
	{ date: "17", value: 23670 },
	{ date: "18", value: 23590 },
	{ date: "19", value: 23480 },
	{ date: "20", value: 23530 },
	{ date: "21", value: 23560 },
	{ date: "22", value: 23550 },
	{ date: "23", value: 23540 },
	{ date: "24", value: 23520 },
	{ date: "25", value: 23520 },
	{ date: "26", value: 23530 },
];

const formatYAxisValue = (value: number): string => {
	if (value === 0) return "0";
	return `${(value / 1000).toFixed(1)} K`;
};

interface CustomDotProps {
	cx?: number;
	cy?: number;
	stroke?: string;
	payload?: IChartData;
	value?: number;
}

const CustomDot: React.FC<CustomDotProps> = (props) => {
	const { cx, cy, stroke, value } = props;

	// We only render the dot if it's not null or undefined
	if (
		value !== null &&
		value !== undefined &&
		cx !== undefined &&
		cy !== undefined
	) {
		return (
			<g>
				<circle
					cx={cx}
					cy={cy}
					r={5}
					fill="#fff"
					stroke={stroke}
					strokeWidth={2}
				/>
			</g>
		);
	}

	return null;
};

type OwnProps = {};
type SlumpTankGraphProps = PropsFromRedux & OwnProps;
function SlumpTankGraph(props: SlumpTankGraphProps) {
	return (
		<>
			<div className="p-4 shadow-md rounded-md border border-gray-300">
				<div className="pb-4">
					<h3>ME SUMP TANK Q-TY</h3>
				</div>
				<ResponsiveContainer width="100%" height={400}>
					<LineChart
						data={chartData}
						margin={{
							top: 5,
							right: 20,
							left: 0,
							bottom: 5,
						}}
					>
						<CartesianGrid
							strokeDasharray="3 3"
							vertical={false}
							stroke="#e0e0e0"
						/>

						<XAxis
							dataKey="date"
							axisLine={false}
							tickLine={false}
							tick={{ fill: "#9e9e9e", fontSize: 12 }}
							padding={{ left: 20, right: 20 }}
						/>

						<YAxis
							domain={[23000, 24000]}
							axisLine={false}
							tickLine={false}
							tick={{ fill: "#9e9e9e", fontSize: 12 }}
							tickFormatter={formatYAxisValue}
							width={50}
						/>

						<Tooltip
							contentStyle={{
								backgroundColor: "#fff",
								border: "1px solid #ccc",
								borderRadius: "8px",
								boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
								fontSize: 12
							}}
							labelStyle={{ color: "#333", fontWeight: 500 }}
							formatter={(value) => [formatYAxisValue(+value), "Value"]}
						/>

						<Line
							type="monotone"
							dataKey="value"
							stroke="#3b82f6"
							strokeWidth={2}
							activeDot={{ r: 8, strokeWidth: 2, fill: "#3b82f6" }} // Dot style on hover
							dot={<CustomDot />}
						/>
					</LineChart>
				</ResponsiveContainer>
			</div>
		</>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(SlumpTankGraph);
